import React from "react";

interface MessageLoadingProps {
  text: string;
}

const MessageLoading: React.FC<MessageLoadingProps> = ({ text }) => {
  return (
    <div className="flex text-sm items-center gap-2 px-4 py-3 bg-neutral-700 text-neutral-200 rounded-lg self-start w-11/12 max-w-11/12">
      <span>{text}</span>
      <div className="flex gap-1">
        <div className="size-1.5 rounded-full bg-neutral-500 animate-bounce [animation-delay:-0.3s]"></div>
        <div className="size-1.5 rounded-full bg-neutral-500 animate-bounce [animation-delay:-0.15s]"></div>
        <div className="size-1.5 rounded-full bg-neutral-500 animate-bounce"></div>
      </div>
    </div>
  );
};

export default MessageLoading;
